<div class="oase-monatlicheplanmenge">

	<mat-card appearance="outlined">
		<mat-card-title>
			{{ OBJ_LNG_NAME+'.wartung' | translate:locale.language }} <span *ngIf="dataSource" class="anzahl"> ({{ 'allgemein.daten.insgesamt' | translate:locale.language:{ count: dataSource.page.totalElements } }})</span>
			<p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>
			<p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>
			<button mat-raised-button id="export_mpm" *ngIf="darfExport" (click)="exportMonatlichePlanmenge();">{{ OBJ_LNG_NAME+'.export' | translate:locale.language }}</button>
		</mat-card-title>

		<mat-card-content>

			<div class="tabelle">
				<div class="tabelle-kopf" [style.display]="">
					<mat-form-field [style.display]="'none'">
						<input matInput #filter>
						<mat-label>
							<i class="material-icons app-input-icon">search</i> {{ 'allgemein.suche' | translate:locale.language }}
						</mat-label>
						<button matSuffix mat-icon-button class="suche" (click)="clearFilter()" matTooltip="{{ 'allgemein.klick.leeresuche' | translate:locale.language }}"
								[disabled]="dataSource.isWaitingForResponse || filter.value == ''"><mat-icon>close</mat-icon></button>
					</mat-form-field>
				</div>

				<!-- Wenn eine Auswahl nicht benötigt wird einfach in displayedColumns die Spalte select nicht einbinden -->

				<div class="ladedaten" *ngIf="dataSource.isWaitingForResponse">
					<div>{{ 'allgemein.daten.laden.start' | translate:locale.language }} <mat-icon>free_breakfast</mat-icon></div>
					<div><mat-spinner color="primary"></mat-spinner></div>
					<div>{{ 'allgemein.daten.laden.ende' | translate:locale.language }}</div>
				</div>

			  <form #insertForm="ngForm" class="{{ OBJ_LNG_NAME }} insertForm" (ngSubmit)="speichere(insertForm.value)">
				<mat-table #table [dataSource]="dataSource" matSort  [style.display]="onDesktop()">

					<ng-container matColumnDef="monatzahl">
						<mat-header-cell *matHeaderCellDef fxFlex="17.47">{{ OBJ_LNG_NAME+'.monat' | translate:locale.language }}</mat-header-cell>
						<mat-cell fxFlex="17.47" *matCellDef="let row">
							{{ row.monat }}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="ablaufdatum1">
						<mat-header-cell *matHeaderCellDef  fxFlex="22.61">{{ OBJ_LNG_NAME+'.anlieferung' | translate:locale.language }}&nbsp;
							<span *ngIf="dataSource.content.length">{{ dataSource.content[1].jahr-2 }}</span></mat-header-cell>
						<mat-cell fxFlex="22.61" *matCellDef="let row">
							<span *ngIf="row.vorletztesjahr>0">{{ row.vorletztesjahr | number }} kg</span>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="ablaufdatum2">
						<mat-header-cell *matHeaderCellDef  fxFlex="22.61">{{ OBJ_LNG_NAME+'.anlieferung' | translate:locale.language }}&nbsp;
							<span *ngIf="dataSource.content.length">{{ dataSource.content[1].jahr-1 }}</span></mat-header-cell>
						<mat-cell fxFlex="22.61" *matCellDef="let row">

							<span *ngIf="row.letztesjahr>0">{{ row.letztesjahr | number }} kg</span>

						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="planmenge">
						<mat-header-cell *matHeaderCellDef  fxFlex="37.32">{{ OBJ_LNG_NAME+'.planmenge' | translate:locale.language }}&nbsp;
							<span *ngIf="dataSource.content.length">{{ dataSource.content[1].jahr }}</span></mat-header-cell>
						<mat-cell fxFlex="37.32" *matCellDef="let row">

							<mat-form-field style="display: none" *ngIf="row.monat != 'Summe'">
								<input matInput [hidden]="true" [(ngModel)]="row.id" name="id" />
							</mat-form-field>
							<mat-form-field style="display: none" *ngIf="row.monat != 'Summe'">
								<input matInput [hidden]="true" [(ngModel)]="row.jahr" name="jahr" />
							</mat-form-field>
						  <mat-form-field *ngIf="row.monat != 'Summe'">
							<input matInput #planmenge="ngModel" *ngIf="alledatengewartet"
								   (ngModelChange)="checkPlanmengeSumme(row.planmenge)"
								   [(ngModel)]="row.planmenge" type="number" disabled
								   name="planmenge{{row.monatzahl}}" maxlength="6" pattern="[0-9]{1,6}" required />
						  <input matInput #planmenge="ngModel" *ngIf="!(alledatengewartet)"
								 (ngModelChange)="checkPlanmengeSumme(row.planmenge)"
								 [(ngModel)]="row.planmenge" type="number"
								 name="planmenge{{row.monatzahl}}" maxlength="6" pattern="[0-9]{1,6}" required />
							<mat-label>
								 {{ OBJ_LNG_NAME+'.eingabewarnung' | translate:locale.language }}
							</mat-label>
						  </mat-form-field>
						  <span *ngIf="row.monat == 'Summe' && row.planmenge != 0">{{row.planmenge | number}} kg</span>
						  <span *ngIf="row.monat == 'Summe' && row.planmenge == 0">{{summeEingabe | number}} kg</span>

						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns; let i = index;" [ngClass]="{'headerZeile': row.monat == 'Summe'}"></mat-row>

				</mat-table>
				<div class="sucheleer" [style.display]="dataSource.page.totalElements > 0 && dataSource.page.searchElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.sucheleer' | translate:locale.language }}
				</div>

				<div class="keinedaten" [style.display]="dataSource.page.totalElements == 0 ? '' : 'none'">
					{{ 'allgemein.daten.keine' | translate:locale.language }}
				</div>

				<mat-paginator #paginator [style.display]="'none'"
							   [length]="dataSource.page.searchElements"
							   [pageIndex]="0"
							   [pageSize]="15"
							   [pageSizeOptions]="[5,10,15,20,25,30,50,100,200,500]">
				</mat-paginator>
				<div class="right" [ngStyle]="{ 'margin-top.px' : '10' }" [style.display]="onDesktop()">
				<button id="savempm" mat-raised-button color="primary" type="submit" [disabled]="!insertForm.valid || ladedaten || alledatengewartet">
					{{ 'allgemein.speichern' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}
				</button>
				</div>
			  </form>
			</div>
		</mat-card-content>
	</mat-card>

	<div [style.display]="onMobile()" class="mobile">
		<form #insertForm="ngForm" class="{{ OBJ_LNG_NAME }} insertForm" (ngSubmit)="speichere(insertForm.value)">
		<mat-card appearance="outlined" *ngFor="let monatlicheplanmenge of dataSource.content" [ngClass]="{'headerZeile': monatlicheplanmenge.monat == 'Summe'}">
			<mat-card-title>
				<span *ngIf="monatlicheplanmenge.monat != 'Summe'">{{ OBJ_LNG_NAME+'.monat' | translate:locale.language }} :</span> {{ monatlicheplanmenge.monat }}
			</mat-card-title>
			<mat-card-content>
				{{ OBJ_LNG_NAME+'.anlieferung' | translate:locale.language }}&nbsp;<span *ngIf="dataSource.content">{{ dataSource.content[0].jahr-2 }}</span> : <span *ngIf="monatlicheplanmenge.vorletztesjahr!=='0'">{{ monatlicheplanmenge.vorletztesjahr | number }} kg</span>
			</mat-card-content>
			<mat-card-content>
				{{ OBJ_LNG_NAME+'.anlieferung' | translate:locale.language }}&nbsp;<span *ngIf="dataSource.content">{{ dataSource.content[0].jahr-1 }}</span> : <span *ngIf="monatlicheplanmenge.letztesjahr!=='0'">{{ monatlicheplanmenge.letztesjahr | number }} kg</span>
			</mat-card-content>
			<mat-card-content>
				<mat-form-field style="display: none"  *ngIf="monatlicheplanmenge.monat != 'Summe'">
					<input matInput [hidden]="true" [(ngModel)]="monatlicheplanmenge.id" name="id" />
				</mat-form-field>
				<mat-form-field style="display: none"  *ngIf="monatlicheplanmenge.monat != 'Summe'">
					<input matInput style="display: none" [hidden]="true" [(ngModel)]="monatlicheplanmenge.jahr" name="jahr" />
				</mat-form-field>
				{{ OBJ_LNG_NAME+'.typ' | translate:locale.language }} : <mat-form-field *ngIf="monatlicheplanmenge.monat != 'Summe'">
							<input matInput #planmenge="ngModel" *ngIf="alledatengewartet" disabled
								   [ngModel]="monatlicheplanmenge.planmenge" type="number"
								   name="planmenge{{monatlicheplanmenge.monatzahl}}" maxlength="6"
								   pattern="[0-9]{1,6}" required />
							<input matInput #planmenge="ngModel" *ngIf="!alledatengewartet"
								   [ngModel]="monatlicheplanmenge.planmenge" type="number"
								   name="planmenge{{monatlicheplanmenge.monatzahl}}" maxlength="6"
								   pattern="[0-9]{1,6}" required />
							<mat-label>
								 {{ OBJ_LNG_NAME+'.eingabewarnung' | translate:locale.language }}
							</mat-label>
						</mat-form-field>
						<span *ngIf="monatlicheplanmenge.monat == 'Summe'">{{monatlicheplanmenge.planmenge | number}} kg</span>
			</mat-card-content>
		</mat-card>
		<mat-card appearance="outlined" *ngIf="!alledatengewartet">
			<mat-card-actions align="end">
				<button mat-raised-button color="primary" type="submit" [disabled]="!insertForm.valid || ladedaten || alledatengewartet">
					{{ 'allgemein.speichern' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}
				</button>
			</mat-card-actions>
		</mat-card>
		</form>
	</div>
</div>